import { TranslatableText } from '@dreryk/react-common';
import {
   AlignItems,
   appendTestableComponentAttributes,
   ContentNodeRenderer,
   IconFillColor,
   IconSize,
   IconWrapper,
   StyledFlex,
   TestId,
} from '@dreryk/react-components';

import { StyledContent, StyledDescription } from './AppointmentDetailsInfoItem.styled';

type AppointmentDetailsInfoItemProps = {
   readonly testId: TestId;
   readonly icon: JSX.Element;
   readonly iconFillColor?: IconFillColor;
   readonly iconAlign?: AlignItems;
   readonly content: TranslatableText | JSX.Element;
   readonly description?: TranslatableText | JSX.Element;
   readonly disabled?: boolean;
   readonly rightContent?: JSX.Element;
};

export const AppointmentDetailsInfoItem = (props: AppointmentDetailsInfoItemProps): JSX.Element => {
   return (
      <StyledFlex
         gap={'4px'}
         alignItems={'center'}
         justifyContent={'space-between'}
         {...appendTestableComponentAttributes('AppointmentDetailsInfoItem', props.testId)}
      >
         <StyledFlex gap={'4px'} alignItems={props.iconAlign ?? AlignItems.CENTER}>
            <IconWrapper
               size={IconSize.SMALL}
               testId={'icon'}
               fillColor={props.iconFillColor ?? IconFillColor.PRIMARY}
               disabled={props.disabled}
            >
               {props.icon}
            </IconWrapper>
            <StyledFlex direction={'column'} gap={'2px'} flex={'1'}>
               <StyledContent $disabled={props.disabled}>
                  <ContentNodeRenderer node={props.content} />
               </StyledContent>
               {props.description ? (
                  <StyledDescription>
                     <ContentNodeRenderer node={props.description} />
                  </StyledDescription>
               ) : null}
            </StyledFlex>
         </StyledFlex>
         {props.rightContent}
      </StyledFlex>
   );
};
